import React from 'react';
import CityPage from '../CityPage/CityPage';
import image from './Bobslake.jpeg';

const BobslakePage = () => (
  <CityPage
    city="Bobs Lake"
    region="Ontario"
    country="Canada"
    countryCode="CA"
    routePath="/bobslake"
    currentPage="BobslakePage"
    image={image}
    imageAlt="Boat rentals on Bobs Lake, Ontario"
    intro="Bobs Lake is one of eastern Ontario's largest, cleanest cottage-country lakes — a maze of islands, bays and pickerel water tucked between Westport and Tay Valley. WetRentals connects you with local hosts who can deliver boats to your dock or to public launches around the lake."
    sections={[
      {
        heading: 'Where to boat on Bobs Lake',
        body:
          'Bobs Lake stretches roughly 25 km with hundreds of islands. Popular launches include the public ramp at Bell Line Road and the marina at Crow Lake. Connecting waters reach Crow Lake to the south and Christie Lake to the east.',
      },
      {
        heading: 'What you can rent on Bobs Lake',
        body:
          'Pontoon boats for family days on the water, fishing boats for bass, pickerel and lake trout, Sea-Doos, kayaks, canoes and paddleboards.',
      },
      {
        heading: 'Why book with WetRentals on Bobs Lake',
        body:
          "WetRentals is Canada's largest peer-to-peer boat rental platform. Every booking includes safety equipment, instant confirmation, host messaging and a flexible cancellation policy.",
      },
    ]}
    searchUrl="/s?address=Bobs%20Lake%2C%20Ontario%2C%20Canada&bounds=44.95%2C-76.30%2C44.50%2C-76.95&mapSearch=true"
    searchLabel="Browse all boat rentals on Bobs Lake"
  />
);

export default BobslakePage;
